export default "__VITE_ASSET__bf236ea6__"